function Animator() {
  let canAnimate = true;

  const planePath = [
    'm 53.7757 23.6376L44.9505 20.0334L54.856 17.827L56.2412 20.3838L53.7757 23.6376ZM8.01988 31.809L8.01759 31.8212L8.03795 31.8123L8.01988 31.809 z',
    'm 49.361 24.0711C48.9413 24.4952 48.0048 25.2545 46.91 24.8601C46.3767 24.6645 24.7899 15.9515 24.7351 15.9373C24.5848 15.8652 24.6688 15.5329 24.9484 15.6204L49.2759 23.7032C49.4286 23.7584 49.4807 23.9525 49.361 24.0711ZM50.0355 15.7794L46.3477 16.8709C46.3477 16.8709 45.6533 16.2532 46.6077 16.0209C46.8532 15.9618 47.425 15.7645 47.8839 15.6249C47.9407 15.6075 47.9912 15.5742 48.0296 15.5289C48.0679 15.4836 48.0924 15.4282 48.1001 15.3694C48.1078 15.3105 48.0985 15.2507 48.0731 15.1971C48.0478 15.1434 48.0076 15.0982 47.9572 15.0667L45.6396 13.5993C46.1256 13.3426 46.8208 13.2651 47.414 13.5694C47.7569 13.7475 49.1595 14.6696 50.0811 15.2729C50.3652 15.4581 50.2406 15.7215 50.0355 15.7794ZM41.6705 16.5983C41.2639 16.7871 38.9805 15.9065 38.9805 15.9065C38.9805 15.9065 42.0292 14.0787 44.5738 14.2464C45.3306 14.2966 46.7207 15.1529 46.7207 15.1529C46.7207 15.1529 43.1238 15.9186 41.6705 16.5983ZM67.2322 21.2346C66.5753 18.6165 66.1471 16.4051 65.9485 15.8577C65.3685 14.2747 64.0936 14.1159 62.9773 14.1015C60.0009 14.0578 58.7818 14.3549 53.4462 14.7512C52.6605 14.8165 51.173 14.9661 50.4458 14.5526C48.5166 13.4669 47.9977 12.7891 46.99 12.7155C45.4275 12.6046 42.0072 13.4908 38.1303 15.3393C36.9185 15.9056 36.8721 16.8429 36.5716 17.4121C36.5566 17.4407 36.5482 17.4723 36.5469 17.5046C36.5456 17.5369 36.5515 17.5691 36.5642 17.5988C36.5769 17.6285 36.596 17.6551 36.6202 17.6765C36.6444 17.6979 36.6731 17.7137 36.7041 17.7227C37.1896 17.8666 42.5212 19.3454 42.7627 19.4258C42.7289 19.4003 42.703 19.3659 42.6877 19.3265C42.6724 19.287 42.6683 19.2441 42.676 19.2025C42.6895 19.1302 42.7372 19.0643 42.8211 19.0406C44.5233 18.4988 50.6904 16.5842 54.3317 15.8848C59.3145 14.9165 60.4704 14.9289 61.9056 15.0601C62.2403 15.0917 62.6979 15.1991 63.0316 15.2833C63.3007 15.3555 63.5093 15.5661 63.5478 15.8324C63.8399 17.8241 64.9282 22.4036 65.6582 23.9879C65.6582 23.9879 65.4215 24.2871 65.0846 24.2417C64.8228 24.1983 64.3846 23.6103 64.1094 23.259C64.0786 23.2227 64.0372 23.1969 63.991 23.1851C63.9449 23.1734 63.8962 23.1764 63.8517 23.1936C57.6507 25.5735 53.3603 26.3149 52.7457 26.4114C52.6953 26.4203 52.6434 26.409 52.6013 26.3798L49.9562 24.7953C49.9562 24.7953 50.0794 24.7254 50.443 24.2474C50.5209 24.1343 50.5775 23.9993 50.5896 23.9093C50.6524 23.4541 50.2356 23.2709 50.0435 23.2084C49.305 22.9739 29.5488 16.2053 24.548 14.7582C22.4258 14.1382 20.165 14.8564 19.0611 15.8443L19.0601 15.8749L21.3866 19.4053C21.4385 19.4851 21.5334 19.5209 21.622 19.4973L24.0849 18.8809C24.0849 18.8809 24.2176 19.8963 23.8976 20.0036C21.8207 20.6819 19.8248 21.2618 17.8879 21.8554C17.108 22.0974 16.994 22.8056 16.5785 23.7556C16.4041 24.1533 16.2848 24.5245 16.2848 24.5245C16.2848 24.5245 20.6103 23.2873 23.248 22.5859C23.2926 22.5746 23.3396 22.5775 23.3825 22.5942C23.4254 22.611 23.462 22.6407 23.4871 22.6792C23.7642 23.1137 23.8619 23.22 24.0533 23.4975C24.0729 23.5256 24.0856 23.5578 24.0903 23.5917C24.095 23.6256 24.0916 23.6601 24.0805 23.6924C24.0693 23.7247 24.0506 23.7539 24.026 23.7776C24.0014 23.8014 23.9715 23.8189 23.9388 23.8289C23.31 24.0236 22.6627 24.2243 22.1595 24.4084C21.7608 24.5545 21.9932 25.3326 21.9932 25.3326L29.1568 23.4548C29.1568 23.4548 29.4922 23.9348 28.682 24.2461C27.4285 24.7385 16.0615 28.074 15.1638 27.93C12.7983 27.5506 9.17668 22.3098 7.69512 21.3383C6.4456 20.5195 4.81649 21.1711 2.62207 21.9598C2.02423 22.1784 2.20927 23.0098 2.20927 23.0098L5.34642 22.0982C5.34642 22.0982 5.62543 22.5724 5.1818 22.7449C3.62977 23.3627 1.45801 23.8651 1.10815 24.029C0.596089 24.2675 0.487335 25.815 0.487335 25.815L3.43345 25.0683C3.52189 25.0453 3.62213 25.0774 3.65312 25.1226L8.43985 31.7175C8.82519 31.6971 9.20802 31.6433 9.58404 31.5566L5.69111 25.5171C5.67269 25.4884 5.66123 25.4558 5.65763 25.4219C5.65403 25.3879 5.6584 25.3536 5.67039 25.3217C5.68237 25.2897 5.70165 25.261 5.72668 25.2378C5.7517 25.2147 5.7818 25.1976 5.81456 25.1881C6.35664 25.0286 6.98526 24.9568 7.70356 25.7513C8.30937 26.4146 10.4051 28.8613 12.8295 29.0928C13.6368 29.1731 13.6046 29.4176 13.6046 29.4176C13.6046 29.4176 12.5012 29.7143 11.1777 30.1456C10.5228 30.3622 10.8453 31.3161 10.8453 31.3161C17.4583 29.9516 25.6084 28.2389 26.7533 27.9814C26.7918 27.9737 26.8316 27.9761 26.8689 27.9884C26.9062 28.0008 26.9396 28.0226 26.966 28.0518L28.4815 29.7871C28.6603 30.2253 42.2036 27.7437 46.4671 26.509C46.7045 26.443 48.6704 26.9016 49.6294 27.0717C50.0697 27.1537 50.0171 27.3424 50.0171 27.3424C50.0171 27.3424 16.04 34.0018 8.33305 32.2653L8.31858 32.2713L6.53352 32.6701C7.38492 33.4887 6.94841 34.5477 8.75643 34.0042C8.81244 34.2485 8.88359 34.5082 8.95614 34.7856C9.14699 35.5393 9.14627 35.5431 11.3768 35.2234C17.6855 34.3305 45.8624 31.3622 52.3008 30.0132C55.935 29.2557 60.9587 28.2108 64.2037 26.9573C67.4043 25.7268 68.1596 24.9251 67.2335 21.2348M72.6366 35.7655L72.5815 35.8247L72.5469 35.7488C72.5251 35.7006 70.3844 30.8902 69.6307 29.0416C69.4027 28.4841 69.8255 28.305 69.8255 28.305L69.8729 28.2872L69.896 28.3316C70.0113 28.5447 72.6434 33.6399 72.9401 34.5422C73.1682 35.218 72.6588 35.7429 72.6366 35.7655ZM73.5104 35.0199C73.4611 34.2412 73.0016 29.0587 72.5424 27.1034L70.1112 20.0023C69.6787 20.398 69.18 20.8161 68.7238 21.1024C68.6399 21.1476 68.5536 21.1843 68.4566 21.2096C68.3422 21.2353 68.2241 21.24 68.108 21.2235L68.8826 27.9235C68.9833 28.9958 69.5031 29.9878 69.9257 30.975C70.1397 31.4645 71.6486 34.9127 72.2304 36.2355C72.3512 36.5119 72.7222 36.5891 72.9314 36.3702C73.3037 35.9854 73.5446 35.4812 73.5104 35.0199 Z',
    'm 67.6084 8.93516L67.5596 8.9528L67.5365 8.90841C67.4244 8.68577 64.7528 3.47978 64.4444 2.55056C64.2217 1.85642 64.7362 1.32173 64.7585 1.29916L64.8138 1.24266L64.8501 1.31625C64.8717 1.36903 67.0496 6.29531 67.8124 8.18095C68.0433 8.75171 67.6136 8.93213 67.6084 8.93516ZM68.6123 9.59122C68.4612 8.15492 67.9329 7.14396 67.5002 6.12879C66.713 4.30653 65.9226 2.48565 65.129 0.666152C65.1042 0.610123 65.066 0.561037 65.0178 0.523204C64.9696 0.485372 64.9129 0.459949 64.8525 0.449168C64.7922 0.438388 64.7302 0.442578 64.6719 0.461373C64.6135 0.480167 64.5607 0.51299 64.5181 0.556961C64.112 0.968903 63.8629 1.53437 63.8964 2.03225C63.9516 2.82544 64.3716 8.09471 64.8372 10.0946L67.1105 16.6125C67.2107 16.5376 67.329 16.4795 67.4569 16.4493C67.5434 16.4299 67.6326 16.4253 67.7207 16.4356C68.1711 16.4882 68.8668 16.6226 69.4958 16.7532L68.6123 9.59122 z',
    'm 67.6932 18.7679L67.3709 17.5368C67.3709 17.5368 67.3056 17.3497 67.5417 17.3015C67.5606 17.297 67.5796 17.2918 67.6022 17.2921C67.6022 17.2921 69.8229 17.6312 70.4905 17.8845C70.8444 18.0213 70.8354 18.1445 70.8354 18.1445L67.6932 18.7679ZM71.03 17.6811C70.1435 17.3195 68.4015 16.9821 67.3456 16.8481C67.3018 16.8399 67.2714 16.8343 67.2313 16.8308C67.2085 16.8312 67.1813 16.8302 67.1541 16.8331C67.1279 16.8375 67.1029 16.8472 67.0806 16.8615C66.9474 16.9202 66.844 17.0632 66.8738 17.1937C67.1419 18.4017 67.4705 19.5955 67.8583 20.7706C67.9093 20.9344 68.1358 21.002 68.3144 20.9685C68.3513 20.9597 68.387 20.9469 68.4211 20.9303C69.4547 20.3307 70.496 19.4032 71.2258 18.4264C71.4502 18.1182 71.3992 17.8328 71.03 17.6811ZM59.8644 15.4203C59.8644 15.4203 59.1645 16.9818 58.1908 18.7542L57.311 17.0812L56.2982 17.3327L57.5947 19.8021C56.7946 21.156 55.8862 22.4816 55.0477 23.2064L56.8938 22.7489C57.3483 22.4609 57.7972 21.7911 58.2032 20.9636L58.917 22.3238L59.9354 22.0707L58.7246 19.7682C59.4055 18.0181 59.8715 16.0629 59.8644 15.4203 z'
  ];

  const propPath = new Path2D();
  propPath.addPath(new Path2D('m 67.7852 67.77C69.3013 66.2692 70.3427 64.3559 70.7802 62.268L89.1502 55.908C89.6202 55.745 90.0262 55.437 90.3102 55.028L119.573 12.848C119.886 12.3968 120.031 11.8499 119.982 11.3029C119.933 10.7558 119.694 10.2434 119.305 9.85501L110.153 0.704007C109.714 0.264702 109.118 0.0179239 108.496 0.0179239C107.875 0.0179239 107.279 0.264702 106.839 0.704007L95.7302 11.813C71.9652 -5.86099 38.6832 -3.51399 17.5802 17.588C14.2036 20.9618 11.2398 24.7249 8.75121 28.798C8.42751 29.3286 8.32784 29.966 8.47412 30.5701C8.6204 31.1741 9.00064 31.6953 9.53121 32.019C10.0618 32.3427 10.6992 32.4424 11.3033 32.2961C11.9073 32.1498 12.4285 31.7696 12.7522 31.239C15.0473 27.4834 17.7805 24.0138 20.8942 20.903C40.1842 1.61301 70.5122 -0.679993 92.3782 15.165L86.6582 20.885C77.9162 14.918 67.3562 12.048 56.7112 12.785C45.3205 13.5762 34.6002 18.4602 26.5282 26.536C24.3243 28.7393 22.3415 31.1531 20.6082 33.743C20.2736 34.2599 20.1557 34.8876 20.2801 35.4906C20.4046 36.0937 20.7612 36.6235 21.2731 36.9657C21.785 37.3079 22.411 37.4349 23.0158 37.3193C23.6206 37.2037 24.1556 36.8548 24.5052 36.348C26.0677 34.0132 27.8552 31.8371 29.8422 29.851C44.0752 15.617 66.6162 13.406 83.2782 24.265L76.4602 31.083C70.4593 27.6802 63.5523 26.218 56.6872 26.897C49.0455 27.6672 41.9042 31.0522 36.4702 36.48C36.0477 36.9229 35.8151 37.5135 35.8223 38.1256C35.8295 38.7377 36.0759 39.3227 36.5087 39.7555C36.9416 40.1883 37.5265 40.4347 38.1386 40.4419C38.7507 40.4491 39.3413 40.2165 39.7842 39.794C48.5712 31.008 62.1202 28.999 72.9992 34.546L58.3802 49.163C56.0476 49.502 53.8861 50.5834 52.2162 52.247C50.6995 53.7482 49.6576 55.6623 49.2202 57.751L30.8502 64.111C30.3802 64.274 29.9742 64.581 29.6912 64.99L0.427209 107.17C0.114251 107.621 -0.0303574 108.168 0.0186239 108.715C0.0676051 109.261 0.307065 109.774 0.695209 110.162L9.84721 119.313C10.0645 119.531 10.3228 119.704 10.6072 119.822C10.8915 119.94 11.1964 120 11.5042 120C12.1042 120 12.7042 119.77 13.1612 119.313L24.2702 108.204C34.5991 115.874 47.125 120.01 59.9902 120C67.871 120.008 75.6757 118.46 82.9569 115.444C90.238 112.429 96.8522 108.006 102.42 102.429C105.07 99.7804 107.467 96.8913 109.582 93.799C109.756 93.5449 109.878 93.2591 109.941 92.9579C110.004 92.6567 110.007 92.3461 109.95 92.0437C109.893 91.7413 109.777 91.4531 109.609 91.1955C109.44 90.9379 109.223 90.7161 108.969 90.5425C108.715 90.369 108.429 90.2472 108.128 90.1841C107.826 90.121 107.516 90.1178 107.213 90.1748C106.911 90.2318 106.623 90.3478 106.365 90.5161C106.108 90.6845 105.886 90.9019 105.712 91.156C103.761 94.0078 101.55 96.6723 99.1062 99.115C79.7852 118.435 49.4962 120.713 27.6192 104.855L33.3412 99.132C42.1614 105.142 52.7541 107.993 63.3992 107.224C74.7501 106.408 85.4268 101.529 93.4722 93.48C95.3555 91.597 97.0781 89.5599 98.6222 87.39C98.9822 86.8834 99.1263 86.2546 99.0227 85.6418C98.9191 85.0291 98.5763 84.4825 98.0697 84.1225C97.5631 83.7625 96.9343 83.6184 96.3215 83.722C95.7088 83.8257 95.1622 84.1684 94.8022 84.675C93.4098 86.6312 91.8564 88.4675 90.1582 90.165C75.9482 104.376 53.3752 106.601 36.7222 95.752L43.5422 88.932C49.5585 92.3441 56.4853 93.8053 63.3672 93.114C70.9885 92.3338 78.1087 88.953 83.5302 83.54C83.9584 83.0982 84.1956 82.5058 84.1909 81.8905C84.1861 81.2753 83.9396 80.6867 83.5046 80.2516C83.0697 79.8165 82.4811 79.5698 81.8659 79.5649C81.2506 79.5599 80.6582 79.797 80.2162 80.225C71.4392 89.003 57.8762 91.017 47.0012 85.475L61.6202 70.855C63.9532 70.5162 66.115 69.4347 67.7852 67.771V67.77ZM108.496 5.67501L114.606 11.785L86.8942 51.729L70.6872 57.339C70.203 55.4083 69.199 53.6472 67.7842 52.247C66.777 51.2439 65.5842 50.4464 64.2722 49.899L108.496 5.67501ZM11.5042 114.342L5.39421 108.232L33.1062 68.288L49.3132 62.678C49.7974 64.6087 50.8014 66.3698 52.2162 67.77C53.2234 68.7732 54.4163 69.5707 55.7282 70.118L11.5042 114.342ZM55.5222 64.448C54.9347 63.8677 54.4685 63.1763 54.1509 62.414C53.8333 61.6517 53.6706 60.8338 53.6722 60.008L53.6752 59.914C53.7112 59.724 53.7222 59.531 53.7102 59.335C53.8618 57.9083 54.5019 56.5778 55.5222 55.569C56.7116 54.3854 58.3223 53.7226 60.0002 53.726C61.6781 53.7226 63.2888 54.3854 64.4782 55.569C65.0657 56.1493 65.5319 56.8408 65.8495 57.603C66.1671 58.3653 66.3299 59.1832 66.3282 60.009L66.3252 60.103C66.2894 60.2938 66.2777 60.4883 66.2902 60.682C66.1386 62.1088 65.4985 63.4392 64.4782 64.448C62.0082 66.906 57.9912 66.905 55.5222 64.448 z'));
  propPath.addPath(new Path2D('m 113.341 82.064C112.778 81.8011 112.134 81.7726 111.55 81.9846C110.966 82.1967 110.49 82.6321 110.226 83.195L110.2 83.252C110.072 83.5317 110 83.834 109.988 84.1415C109.977 84.4491 110.026 84.7559 110.133 85.0445C110.24 85.333 110.403 85.5977 110.612 85.8233C110.821 86.0489 111.073 86.2311 111.353 86.3595C111.633 86.4879 111.935 86.5599 112.242 86.5714C112.55 86.583 112.857 86.5339 113.145 86.4268C113.434 86.3198 113.699 86.157 113.924 85.9477C114.15 85.7384 114.332 85.4867 114.46 85.207L114.473 85.179C114.736 84.6158 114.765 83.9713 114.552 83.3871C114.34 82.803 113.904 82.3271 113.341 82.064ZM7.65037 35.765C7.07843 35.5223 6.43348 35.5166 5.85739 35.7494C5.28129 35.9821 4.82122 36.4341 4.57837 37.006L4.55737 37.056C4.41108 37.4114 4.35464 37.7973 4.39306 38.1797C4.43148 38.5621 4.56357 38.9291 4.77763 39.2483C4.9917 39.5675 5.28114 39.829 5.62035 40.0096C5.95955 40.1903 6.33806 40.2845 6.72237 40.284C7.64437 40.284 8.52237 39.734 8.89537 38.83C9.39537 37.64 8.83937 36.27 7.65037 35.765 z'));

  const canvas = document.querySelector('.planeCanvas');
  const ctx = canvas.getContext('2d');

  // resize the canvas to fit the window and keep mthe aspect ratio 1:0.6
  // masterW is the width we want the game and HUD to be sized to. 25 allows for the padding left and right
  ctx.globalCompositeOperation = 'destination-over';
  //let masterW = window.innerWidth - 25;
  let animationDivWidth = document.querySelector('.animation').offsetWidth;
  const masterW = animationDivWidth - 25;
  const CanW = masterW;
  const CanH = masterW * 0.6;

  const labelTop = (70 * CanH) / 100;
  const progressTop = labelTop + 25;

  ctx.canvas.width = CanW;
  ctx.canvas.height = CanH;
  document.querySelector('.animation').style.height = CanW * 0.6 + 25 + 'px';

  // maxMultiplyer is the random number of the multiplyer the game needs to reach
  let maxMultiplyer = (Math.round(getRandomNumber(1, 200) * 100) / 100).toFixed(2);
  let multiplyer = 0;
  let gameRoundComplete = false;
  let loadingScreenActive = true;

  // we resize the canvas so lets resize the canvas container
  //const animContainer = document.querySelector(".animation");
  const offset = 20; // offset for the vertical and horizontal lines

  const planeSpeed = 0.5;
  const dotSpeed = 0.1; // Adjust the speed of dot animation
  const scaleAmt = 1; // scale of the plane here
  const lineThickness = 2; //thickness of red trailing line

  let planeAnimationCompleted = false; // Flag to track if plane animation is completed

  const dotRadius = 2;
  const maxDots = 10;

  let horizontalOffset = offset; // Adjust the starting position of horizontal dots from the right
  let verticalOffset = offset; // the point where the dots dissapear HEIGHT minus this value
  const horizontalDotsY = CanH - (offset * 0.5);
  const verticalDotsX = (offset / 2);
  let randY = getRandomNumber(130, 250);

  let planeX = offset + offset;
  let planeY = CanH - offset;

  let movingState = 1;

  const destinationX = CanW - 120;
  const destinationY = 60;

  let verticalDots = [];
  let horizontalDots = [];

  // Initialize vertical dots positions
  for (let i = 0; i < maxDots; i++) {
    verticalDots.push({ x: verticalDotsX, y: i * (CanH - verticalOffset) / maxDots });
  }

  // Initialize horizontal dots positions
  for (let i = 0; i < maxDots; i++) {
    const dotX = i * (CanW - horizontalOffset) / (maxDots - 1) + horizontalOffset;
    horizontalDots.push({ x: dotX + offset, y: horizontalDotsY });
    //
  }

  function drawPlane() {
    const cp2X = (planeX / 8) * 7;
    const cp2Y = planeY + ((CanH - offset - planeY) / 3);

    if (movingState < 4) {
      //draw solid trail behind plane
      ctx.beginPath();
      ctx.fillStyle = 'rgba(107, 16, 34, 0.8)';
      ctx.moveTo(offset, CanH - offset);
      ctx.bezierCurveTo((planeX / 4), CanH - offset, cp2X, cp2Y, planeX, planeY);
      ctx.lineTo(planeX, CanH - offset);
      ctx.lineTo(offset, CanH - offset);
      ctx.fill();

      //draw the line trail behind plane
      ctx.beginPath();
      ctx.strokeStyle = '#E30439';
      ctx.lineWidth = lineThickness;
      ctx.moveTo(offset, CanH - offset);
      ctx.bezierCurveTo((planeX / 4), CanH - offset, cp2X, cp2Y, planeX, planeY);
      ctx.stroke();
    }

    //draw the plane
    ctx.fillStyle = '#E30439';
    ctx.translate(planeX - 10, planeY - (60 * 0.6));
    ctx.scale(scaleAmt, scaleAmt);

    for (let i = 0; i < planePath.length; i++) {
      const path = new Path2D(planePath[i]);
      ctx.fill(path);
    }

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    drawRoundedRect(ctx, offset, -1, CanW + offset, CanH - offset, 0, 'rgba(227, 4, 57, 0)', '#422F33', lineThickness + 1);
  }

  function drawDots() {

    ctx.fillStyle = 'rgba(227, 4, 57, 0.9)';

    // Draw vertical dots
    for (let i = 0; i < verticalDots.length; i++) {
      const dot = verticalDots[i];
      ctx.fillStyle = '#1296D4'; // Set color for vertical dots
      ctx.beginPath();
      ctx.arc(dot.x, dot.y, dotRadius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.closePath();
    }

    // Draw horizontal dots
    for (let i = 0; i < horizontalDots.length; i++) {
      const dot = horizontalDots[i];
      ctx.fillStyle = 'white'; // Set color for horizontal dots
      ctx.beginPath();
      ctx.arc(dot.x, dot.y, dotRadius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.closePath();
    }
  }

  function planeAnimation() {
    ctx.clearRect(0, 0, CanW, CanH);

    if (movingState == 1) {
      if (planeX < destinationX) {
        planeX += planeSpeed;
      }
      if (planeY > destinationY) {
        planeY -= planeSpeed / 2.2;
      }
      if (planeX >= destinationX && planeY <= destinationY) {
        //animation state 1 done! 
        movingState = 2;
        planeAnimationCompleted = true;
        // 
      }
    }

    if (movingState == 2) {
      if (planeY < randY) {
        planeY += planeSpeed / 5.5;
        planeX -= planeSpeed / 5;
      }

      if (planeY >= randY) {
        //animation state 2 done!
        randY = getRandomNumber(100, ((CanH / 4) * 3));
        //
        movingState = 3;
      }
    }

    if (movingState == 3) {
      if (planeY > randY) {
        planeY -= planeSpeed / 5.5;
        planeX += planeSpeed / 5;
      }
      if (planeY <= randY) {
        randY = getRandomNumber(100, ((CanH / 4) * 1.5));
        movingState = 2;
      }
    }

    if (movingState == 4) {
      // this is the 'FLEW AWAY' screen
      if (planeY < CanW) {
        planeX += planeSpeed * 4;
      }
    }

    // Only animate dots if plane animation is completed
    if (planeAnimationCompleted) {
      // Animation logic for dots
      // Update vertical dots positions
      for (let i = 0; i < verticalDots.length; i++) {
        const dot = verticalDots[i];
        dot.y += dotSpeed;

        // If dot reaches the bottom, reset its position to the top
        if (dot.y > CanH - verticalOffset) {
          dot.y = 0;
        }
      }

      // Update horizontal dots positions
      for (let i = 0; i < horizontalDots.length; i++) {
        const dot = horizontalDots[i];
        dot.x -= dotSpeed;

        // If dot reaches the horizontal offset, reset its position to the left edge
        if (dot.x <= horizontalOffset) {
          dot.x = CanW;
        }
      }

    }
    drawPlane();
    drawDots();

    if (multiplyer >= maxMultiplyer) {
      movingState = 4; // 4 is the last stage
      endOfRound();
    } else {
      updateMultiplyer();
      document.querySelector('.multiplyer').textContent = (Math.round(multiplyer * 100) / 100).toFixed(2) + 'x ';
    }
    if (!loadingScreenActive) {
      // stop the animation here if the loading screen is visible
      if (canAnimate) requestAnimationFrame(planeAnimation);
    }
  }

  let rand = getRandomNumber(0, 200);
  function updateMultiplyer() {
    // this increases the multiplier amount
    rand = getRandomNumber(0, 200);
    if (rand > 170) {
      multiplyer += getRandomNumber(0, 1.002);
    }
  }

  let callOnceCheck = 0;
  let tid = 0;
  function endOfRound() {
    if (callOnceCheck == 0) {
      callOnceCheck = 1;
      gameRoundComplete = true;
      multiplyer = maxMultiplyer;
      planeAnimationCompleted = false;

      document.querySelector('.message').style.display = 'block';
      document.querySelector('.message').style.top = '70px';
      document.querySelector('.message').innerHTML = 'FLEW AWAY!';
      document.querySelector('.multiplyer').style.color = '#E30439';
      document.querySelector('.multiplyer').textContent = maxMultiplyer + 'x ';

      tid = setTimeout(loadingScreen, 5000);
    }
  }

  function startOfRound() {
    loadingScreenActive = false;
    planeX = offset + offset;
    planeY = CanH - offset;
    ctxProp.clearRect(0, 0, canvas.width, canvas.height);
    document.querySelector('.multiplyer').style.display = 'block';

    gameRoundComplete = false;
    planeAnimationCompleted = false;
    multiplyer = 0;
    movingState = 1;
    document.querySelector('.message').innerHTML = '';
    document.querySelector('.message').style.display = 'none';
    document.querySelector('.multiplyer').style.color = 'white';
    document.querySelector('.multiplyer').textContent = (Math.round(multiplyer * 100) / 100).toFixed(2) + 'x ';
    callOnceCheck = 0;
  }


  function loadingScreen() {
    maxMultiplyer = (Math.round(getRandomNumber(1, 200) * 100) / 100).toFixed(2);

    gameRoundComplete = false;
    loadingScreenActive = true;
    progressCount = 1;

    document.querySelector('.multiplyer').style.display = 'none';
    document.querySelector('.message').style.display = 'block';
    document.querySelector('.message').innerHTML = 'WAITING FOR NEXT ROUND';
    document.querySelector('.message').style.top = `${labelTop}px`;

    animateProp();
  }

  function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
  }

  // draw HUD ELEMENTS
  const canvasProp = document.querySelector('.HUDCanvas');
  const ctxProp = canvasProp.getContext('2d');

  ctxProp.globalCompositeOperation = 'destination-over';

  let rotation = 0;
  //canvasProp.width = CanW;
  //canvasProp.height = CanH;

  canvasProp.width = masterW;
  canvasProp.height = masterW * 0.6;

  let rotSpeed = 0.03;
  const xPos = CanW / 2;
  const yPos = CanH / 2 - 25;
  let progressCount = 1;


  const animateProp = () => {
    //ctx.fillStyle = "rgba(0 , 0 , 0 , 1)";
    ctxProp.clearRect(0, 0, CanW, CanH);
    // ctx.fillRect(0 , 0 , canvas.width , canvas.height);
    ctxProp.fillStyle = '#E30439';
    ctxProp.translate(xPos, yPos);

    const scaleAmt = 0.6;
    let centreTranslate = 60 * scaleAmt * -1;
    ctxProp.rotate(rotation);
    ctxProp.translate(centreTranslate, centreTranslate);

    ctxProp.scale(scaleAmt, scaleAmt);

    rotation += rotSpeed;
    ctxProp.fill(propPath);
    ctxProp.resetTransform();

    progressCount -= 0.002;
    if (progressCount > 0) {
      drawProgressBar(progressCount);
      if (canAnimate) requestAnimationFrame(animateProp);
    } else {
      startOfRound();
      if (canAnimate) requestAnimationFrame(planeAnimation);
    }

  };
  function drawProgressBar(progress) {
    // Draw background with rounded corners

    if (progress < 0.05) {
      progress = 0.05;
    }

    let barxpos = (CanW / 4);// width of the progress bar
    drawRoundedRect(ctxProp, barxpos, progressTop, (CanW / 2), 6, 2, '#333333', '#333333', 0);

    // Draw progress bar with rounded corners
    const barWidth = (CanW / 2) * progress;
    drawRoundedRect(ctxProp, barxpos, progressTop, barWidth, 6, 2, '#E30439', '#E30439', 0);
  }

  // ---------------------
  // OVERLAY
  // ---------------------

  function drawRoundedRect(ctx, x, y, width, height, cornerRadius, fillColor, strokeColor, strokeWidth) {
    ctx.beginPath();
    ctx.moveTo(x + cornerRadius, y);
    ctx.arcTo(x + width, y, x + width, y + height, cornerRadius);
    ctx.arcTo(x + width, y + height, x, y + height, cornerRadius);
    ctx.arcTo(x, y + height, x, y, cornerRadius);
    ctx.arcTo(x, y, x + width, y, cornerRadius);
    ctx.closePath();

    // Set fill color if provided
    if (fillColor) {
      ctx.fillStyle = fillColor;
      ctx.fill();
    }

    // Set stroke color and width if provided
    if (strokeColor) {
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = strokeWidth || 1; // Default to 1 if strokeWidth is not provided
      ctx.stroke();
    }
  }

  // ---------------------
  /// RAYS
  // ---------------------
  const circleCanvas = document.querySelector('.circleCanvas');
  const circleCtx = circleCanvas.getContext('2d');
  circleCtx.canvas.width = masterW;
  circleCtx.canvas.height = masterW * 0.6;


  // Get canvas size from HTML attributes
  const canvasWidth = circleCanvas.width;
  const canvasHeight = circleCanvas.height;

  // Set canvas size
  circleCanvas.width = canvasWidth;
  circleCanvas.height = canvasHeight;

  // Circle parameters
  const circleRadius = canvasWidth + 200;  // Set the radius automatically
  const centerX = 0;  // Bottom left
  const centerY = canvasHeight;
  const numSlices = 60;
  const sliceColor1 = 'rgba(0, 0, 0, 0)';       // Transparent
  const sliceColor2 = 'rgba(255, 255, 255, 0.1)';  // 10% white

  // Rotation variables
  let rotationAngle = 0;
  const rotationSpeed = 0.0025;  // Adjust rotation speed

  function drawCircle() {
    circleCtx.clearRect(0, 0, circleCanvas.width, circleCanvas.height);

    // Move origin to the bottom left corner.
    circleCtx.translate(centerX, centerY);

    // Rotate the canvas
    circleCtx.rotate(rotationAngle);

    // Draw slices
    for (let i = 0; i < numSlices; i++) {
      const startAngle = (i * (360 / numSlices)) * (Math.PI / 180);
      const endAngle = ((i + 1) * (360 / numSlices)) * (Math.PI / 180);

      circleCtx.beginPath();
      circleCtx.moveTo(0, 0);
      circleCtx.arc(0, 0, circleRadius, startAngle, endAngle);

      // Alternate slice colors
      circleCtx.fillStyle = (i % 2 === 0) ? sliceColor1 : sliceColor2;
      circleCtx.fill();

      // Uncomment the next line if you want to see the outline of each slice
      // circleCtx.stroke();

      circleCtx.closePath();
    }

    // Restore canvas transformations
    circleCtx.rotate(-rotationAngle);
    circleCtx.translate(-centerX, -centerY);

    // Update rotation angle for the next frame
    rotationAngle += rotationSpeed;

    // Request the next animation frame
    if (canAnimate) requestAnimationFrame(drawCircle);
  }

  // Start the drawing
  //drawCircle();
  function startAnimation() {
    canAnimate = true;
    loadingScreen();
    drawCircle();
  }

  function stopAnimation() {
    canAnimate = false;
    clearTimeout(tid);
  }

  this.startAnimation = startAnimation;
  this.stopAnimation = stopAnimation;
}

export default Animator;